/* IVG.PK Premium — theme.js */
(function () {
  'use strict';

  const VP = window.VP = window.VP || {};

  /* ============ UTILITIES ============ */
  VP.util = {
    formatMoney(cents) {
      const amt = Math.round(cents / 100);
      return 'Rs.' + amt.toLocaleString();
    },
    fetchJSON(url, opts = {}) {
      return fetch(url, { ...opts, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', ...(opts.headers || {}) } })
        .then(r => r.ok ? r.json() : Promise.reject(r.status));
    }
  };

  /* ============ MOBILE MENU ============ */
  VP.menu = {
    init() {
      const toggle = document.querySelector('[data-menu-toggle]');
      const close = document.querySelector('[data-menu-close]');
      const menu = document.getElementById('MobileMenu');
      if (!toggle || !menu) return;
      toggle.addEventListener('click', () => menu.classList.add('is-open'));
      close?.addEventListener('click', () => menu.classList.remove('is-open'));
    }
  };

  /* ============ ANNOUNCEMENT BAR ROTATION ============ */
  VP.announce = {
    init() {
      const tracks = document.querySelectorAll('[data-announce]');
      tracks.forEach(track => {
        const msgs = track.querySelectorAll('.announce-msg');
        if (msgs.length < 2) return;
        let i = 0;
        setInterval(() => {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, 3500);
      });
    }
  };

  /* ============ CART DRAWER ============ */
  VP.cart = {
    drawer: null, body: null, foot: null, overlay: null, state: null,

    init() {
      this.drawer = document.getElementById('CartDrawer');
      this.body = document.getElementById('CartDrawerBody');
      this.foot = document.getElementById('CartDrawerFoot');
      this.overlay = document.getElementById('CartOverlay');
      if (!this.drawer) return;

      document.querySelectorAll('[data-cart-toggle]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.open(); }));
      document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', () => this.close()));
      this.overlay?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });

      // Quick-add buttons
      document.addEventListener('click', e => {
        const btn = e.target.closest('[data-quick-add]');
        if (!btn) return;
        e.preventDefault();
        const id = btn.dataset.quickAdd;
        if (!id) return;
        this.add(id, 1);
      });

      // Intercept product detail form (PDP) so ATC adds via AJAX instead of full-page submit
      document.addEventListener('submit', e => {
        const form = e.target.closest('[data-product-form], form[action="/cart/add"]');
        if (!form) return;
        const idField = form.querySelector('input[name="id"]');
        if (!idField || !idField.value) return;
        e.preventDefault();
        const qtyField = form.querySelector('input[name="quantity"]');
        const qty = qtyField ? parseInt(qtyField.value) || 1 : 1;
        this.add(idField.value, qty);
      });

      this.fetch();
    },

    fetch() {
      VP.util.fetchJSON('/cart.js').then(state => { this.state = state; this.render(); this.updateHeaderCount(); });
    },

    add(id, qty = 1) {
      VP.util.fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id, quantity: qty }) })
        .then(() => { this.fetch(); this.open(); });
    },

    update(key, qty) {
      VP.util.fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(() => this.fetch());
    },

    open() {
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
    },
    close() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
    },

    updateHeaderCount() {
      const count = this.state ? this.state.item_count : 0;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.dataset.count = count;
      });
    },

    render() {
      if (!this.state || this.state.item_count === 0) {
        this.body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p></div>';
        this.foot.innerHTML = '';
        return;
      }

      const threshold = parseInt(document.body.dataset.shippingThreshold || '5000') * 100;
      const total = this.state.total_price;
      const remaining = Math.max(0, threshold - total);
      const pct = Math.min(100, (total / threshold) * 100);
      let shippingHtml = '';
      if (threshold > 0) {
        shippingHtml = `
          <div class="cart-shipping-bar">
            <div class="cart-shipping-bar-text">
              ${remaining > 0
                ? `Add <strong>${VP.util.formatMoney(remaining)}</strong> more for free delivery`
                : `🎉 You've unlocked free delivery!`}
            </div>
            <div class="cart-shipping-bar-track"><div class="cart-shipping-bar-fill" style="width: ${pct}%"></div></div>
          </div>
        `;
      }

      const items = this.state.items.map(item => `
        <div class="cart-item">
          <div class="cart-item-img">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
          <div>
            <div class="cart-item-name">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-meta">${item.variant_title}</div>` : ''}
            <div class="cart-item-controls">
              <button class="cart-qty-btn" data-cart-qty="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span class="cart-qty-display">${item.quantity}</span>
              <button class="cart-qty-btn" data-cart-qty="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <button class="cart-item-remove" data-cart-qty="${item.key}" data-qty="0">Remove</button>
          </div>
          <div class="cart-item-price">${VP.util.formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');

      this.body.innerHTML = shippingHtml + items;
      this.foot.innerHTML = `
        <div class="cart-totals">
          <span class="total-label">Subtotal</span>
          <span class="total-value">${VP.util.formatMoney(total)}</span>
        </div>
        <p style="font-size:11px;color:var(--text-muted);margin-bottom:14px;">Shipping calculated at checkout. Cash on Delivery available.</p>
        <a href="${SHOP.cartUrl}" class="btn btn-primary btn-block btn-lg">Checkout <span class="arrow">→</span></a>
      `;

      this.body.querySelectorAll('[data-cart-qty]').forEach(b => b.addEventListener('click', e => {
        const key = e.currentTarget.dataset.cartQty;
        const qty = parseInt(e.currentTarget.dataset.qty);
        this.update(key, qty);
      }));
    }
  };

  /* ============ INIT ============ */
  document.addEventListener('DOMContentLoaded', () => {
    VP.menu.init();
    VP.announce.init();
    VP.cart.init();
  });
})();
